import React from "react";
import Flag from "../../Common/Components/Flag.jsx";
import HighlightableText from "../../Common/HighlightableText.jsx";

const ResultDetail = ({
  place,
  name,
  points,
  country,
  marked,
  sportsmanId,
  onDetailsClick,
}) => (
  <tr>
    <td>{place}.</td>
    <td>
      <Flag code={country} />
      <HighlightableText active={marked}>{name}</HighlightableText>
    </td>
    <td
      onClick={() => {
        onDetailsClick(sportsmanId);
      }}
      style={{ cursor: "pointer", color: "#82bc3d", fontWeight: "bold" }}
    >
      {points}
    </td>
  </tr>
);

const ResultDetailsTable = ({ details, marked, onDetailsClick }) => {
  if (!details) return null;
  return (
    // <table className="zw-tbl result__details">
    <table className="zw-tbl result__details">
      <tbody>
        {details.map((detail, key) => (
          <ResultDetail
            key={key}
            marked={marked.indexOf(detail.sportsmanId) !== -1}
            onDetailsClick={onDetailsClick}
            {...detail}
          />
        ))}
      </tbody>
    </table>
  );
};

export default ResultDetailsTable;
